export default {

	// 需要验证权限的路由
	authPath: {
		'/': {
			access: 'isAuthenticated()'
		},
		'/security/exit-switch': {
			access: 'hasAnyAuthority("ROLE_PREVIOUS_ADMINISTRATOR")'
		},
		'/mc/me': {
			access: 'isAuthenticated()'
		},
		'/admin/setting': {
			access: 'hasAnyAuthority("__SYS_ADMIN")'
		},
		'/admin/config': {
			access: 'hasAnyAuthority("__SYS_ADMIN")'
		},
		'/admin/user/index': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_用户管理")'
		},
		'/admin/user/edit': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_用户管理")'
		},
		'/admin/role/index': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_角色管理")'
		},
		'/admin/role/edit': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_角色管理")'
		},
		'/admin/shop/index': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_微商城管理")'
		},
		'/admin/shop/edit': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_微商城管理")'
		},
		'/admin/school/index': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_驾校管理")'
		},
		'/admin/school/edit': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_驾校管理")'
		},
		'/admin/school/fxindex': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_驾校管理")'
		},
		'/admin/school/lbindex': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_驾校管理")'
		},
		'/admin/school/headmasterindex': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_校长助手管理")'
		},
		'/admin/school/headmasteredit': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_校长助手管理")'
		},
		'/admin/school/signupbill': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_驾校报名账单管理")'
		},
		'/admin/order/index': {
			access: 'hasAnyAuthority("__SYS_ADMIN","__ADMIN_订单管理")'
		},
		'/mc/school/index': {
			access: 'isAuthenticated()'
		},
		'/mc/school/aftersalefee': {
			access: 'isAuthenticated()'
		},
		'/mc/school/serverfee': {
			access: 'isAuthenticated()'
		},
		'/mc/school/fxfee': {
			access: 'isAuthenticated()'
		},
		'/mc/school/lbfee': {
			access: 'isAuthenticated()'
		},
		'/mc/school/facefee': {
			access: 'isAuthenticated()'
		},
		'/mc/school/headmaster': {
			access: 'isAuthenticated()'
		},
		'/mc/school/signupbill': {
			access: 'isAuthenticated()'
		},
		'/mc/shop/serverfee': {
			access: 'isAuthenticated()'
		},
		'/mc/school/order': {
			access: 'isAuthenticated()'
		},
		'/mc/order/index': {
			access: 'isAuthenticated()'
		},
	},

	// 验证权限表达式，返回true或false
	authEL: {
		// 无
		permitAll() {
			return true;
		},
		// 已登录
		isAuthenticated() {
			return sessionStorage.getItem('token') != null;
		},
		// 拥有指定权限中的一个
		hasAnyAuthority(...authorites) {
			if (sessionStorage.getItem('token') == null) {
				return false;
			}
			let user = JSON.parse(sessionStorage.getItem('user'));
			let target = authorites.find(value => {
				if (user == null) {
					return false;
				}
				if (user.authorites == null || user.authorites.length == 0) {
					return false;
				}
				return user.authorites.includes(value);
			});
			if (target !== undefined) {
				return true;
			}
			return false;
		}
	},

	auth(path) {
		let access = null;
		if (this.authPath[path] != null) {
			access = this.authPath[path].access;
		}
		if (access == null) {
			return true;
		}
		return eval('this.authEL.' + access);
	},
}


// WEBPACK FOOTER //
// ./src/security.js